//=============================================================================
//                       <--- Developed By Icon Team ---> 18 January 2021
//=============================================================================

// npm packages
import React, { useState, useEffect, useContext, useCallback } from 'react';
import context from 'context/context';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import * as moment from 'moment';

// custom pages
import Table from 'components/Table/Table';
import maxMerch from 'apis/maxmerch/maxmerch';
import useDebounce from 'helpers/useDebounce';
import { styles } from './styles';
import Loader from 'components/Loader/Loader';
import searchIcon from 'assets/img/Search_Icon.png';
import audit from 'apis/audit/audit';
import access from 'config/access';
import HistoryTable from 'components/Table/History/HistoryTable';

// material-ui
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Card from '@material-ui/core/Card';
import Badge from '@material-ui/core/Badge';
import Checkbox from '@material-ui/core/Checkbox';
import Dialog from '@material-ui/core/Dialog';

// material-ui icons
import FilterListIcon from '@material-ui/icons/FilterList';
import Grid from '@material-ui/core/Grid';
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined';
import SearchOutlinedIcon from '@material-ui/icons/SearchOutlined';
import EditIcon from '@material-ui/icons/Edit';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import HistoryIcon from '@material-ui/icons/History';
import { blockInvalidChar } from 'helpers/blockInvalidChar';

import { useTranslation } from 'react-i18next';

// custom TextField
const CssTextField = withStyles({
  root: {
    '& label.Mui-focused': {
      color: '##D3D3D3',
    },
    '& .MuiFormLabel-root': {
      color: '#707070',
    },
    '& .MuiInputBase-input': {
      color: '#707070',
    },
    '& .MuiInput-underline:before': {
      borderBottomColor: '#707070!important',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: '#707070!important',
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#707070',
      },
      '&:hover fieldset': {
        borderColor: '#707070',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#707070',
      },
      '&.MuiOutlinedInput-root': {
        borderRadius: 20,
      },
      '&.MuiOutlinedInput-root': {
        marginTop: 0,
        borderRadius: 20,
      },
    },
  },
})(TextField);

export default function LoyalytyUsers(props) {
  const { state, dispatch } = useContext(context);
  const {
    search,
    getMaxMerch,
    filter,
    update,
    getTier,
    getCronJob,
    updateCronJob,
  } = maxMerch();
  const { getAudit } = audit();

  const classes = styles();

  const [data, setData] = useState([]);
  const [selectedData, setSelectedData] = useState([]);
  const [offset, setOffset] = useState(1);
  const [count, setCount] = useState(0);
  const [filterCard, setFilterCard] = useState(false);
  const [searchValue, setSearchValue] = useState(null);
  const searchBounceValues = useDebounce(searchValue);
  const history = useHistory();
  const { t, i18n } = useTranslation();
  const [states, setstates] = useState({
    filter: false,
    filterTier: '',
    filterAppliedTier: '',
    tier: [],
    max_merch_cron_job: '',
    editId: '',
    isEdit: false,
    loyalty_id: '',
    sales_summary_tier: '',
    max_merch_tier: '',
    historyLoader: false,
  });

  const [editObj, setEditObj] = useState({});
  const [updateObj, setUpdateObj] = useState({});

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  const { historyLoader } = states;

  // For bread-crumbs
  useEffect(() => {
    dispatch({ type: 'SET_PATHNAME', payload: ['HOME', 'ADMIN', 'Max Merch'] });
  }, []);

  // handling api calls
  useEffect(() => {
    states.filter
      ? handleFilter()
      : searchValue && searchValue.length > 0
        ? handleSearch()
        : handleGet();
  }, [offset]);

  // handling search api
  useEffect(() => {
    if (searchBounceValues && searchBounceValues.length > 0) {
      handleSearch();
    } else {
      setOffset(1);
    }
  }, [searchBounceValues]);

  // change pagination func
  const handlePagination = (value) => {
    setOffset(value);
  };

  // roles api func
  useEffect(() => {
    handleGetTier();
    handleGetCronJob();
  }, []);

  // tier api func
  const handleGetTier = async () => {
    try {
      let res = await getTier();
      if (res) {
        setStates({ tier: res.data });
      }
    } catch (e) {
      console.log({ e });
    }
  };

  // cron job api func
  const handleGetCronJob = async () => {
    try {
      let res = await getCronJob();
      if (res) {
        setStates({ max_merch_cron_job: res.max_merch_cron_job });
      }
    } catch (e) {
      console.log({ e });
    }
  };

  // update cron job api func
  const handleUpdateCronJob = async () => {
    try {
      let values = {
        max_merch_cron_job: !states.max_merch_cron_job,
      };
      let res = await updateCronJob(values);
      if (values.max_merch_cron_job) {
        handleGet();
      }
      if (res) {
        setStates({ max_merch_cron_job: res.max_merch_cron_job });
        if (res.max_merch_cron_job) {
          history.push('/dashboard/upload-success', {
            type: 'Cron is Activated',
          });
        } else {
          history.push('/dashboard/upload-success', {
            type: 'Cron is Deactivated',
          });
        }
      }
    } catch (e) {
      console.log({ e });
    }
  };

  // authorized members api func
  const handleGet = async () => {
    try {
      let values;
      values = {
        offset: (offset - 1) * 10,
        limit: 10,
      };
      dispatch({ type: 'SET_LOADING', payload: true });
      let res = await getMaxMerch(values);
      if (res) {
        setData(res.data);
        setCount(res.count);
        dispatch({ type: 'SET_LOADING', payload: false });
      }
    } catch (e) {
      console.log({ e });
    }
  };

  // search api func
  const handleSearch = async () => {
    setStates({ filter: false, filterTier: '', filterAppliedTier: '' });
    try {
      let values;

      if (!searchValue.replace(/\s/g, '').length) {
        return;
      }
      values = {
        search: searchValue,
        offset: (offset - 1) * 10,
        limit: 10,
      };
      dispatch({ type: 'SET_LOADING', payload: true });
      let res = await search(values);
      if (res) {
        setData(res.data);
        setCount(res.count);
        dispatch({ type: 'SET_LOADING', payload: false });
        return;
      }
      dispatch({ type: 'SET_LOADING', payload: false });
      setData([]);
    } catch (e) {
      console.log({ e });
    }
  };

  // filter api func
  const handleFilter = async () => {
    try {
      let values;

      if (!states.filterTier && !states.filterAppliedTier) {
        return;
      }
      values = {
        offset: (offset - 1) * 10,
        limit: 10,
      };
      if (states.filterTier) {
        values = { ...values, tier: states.filterTier };
      }
      if (states.filterAppliedTier) {
        values = { ...values, applied_tier: states.filterAppliedTier };
      }
      dispatch({ type: 'SET_LOADING', payload: true });
      let res = await filter(values);
      if (res) {
        setData(res.data);
        setCount(res.count);
        setFilterCard(false);
        setStates({ filter: true });
        dispatch({ type: 'SET_LOADING', payload: false });
      } else {
        setFilterCard(false);
      }
    } catch (e) {
      console.log({ e });
    }
  };

  // search api func
  const handleExecute = async () => {
    try {
      let obj = {
        loyaltyArray: selectedData,
      };

      let res = await update(obj);
      if (res && res.type === 'success') {
        if (res?.updated?.length > 0) {
          if (searchValue?.length > 0) {
            handleSearch();
          } else if (states?.filter) {
            handleFilter();
          } else {
            handleGet();
          }
          toast.success(res?.message ? res?.message : t('Something Went Wrong'), {
            toastId: 'max-merch-updated',
          });
        } else {
          toast.error(res?.message ? res?.message : t('Something Went Wrong'), {
            toastId: 'max-merch-not-updated',
          });
        }
        setSelectedData([]);
        return;
      }
    } catch (e) {
      console.log({ e });
    }
  };

  const handleGetHistoryData = async (id) => {
    try {
      let values;
      values = {
        recordId: id,
        key: 'la',
      };
      let res = await getAudit(values);
      if (res) {
        setStates({ historyData: res?.data, historyLoader: false });
      }
    } catch (e) {
      console.log({ e });
    }
  };

  return (
    <React.Fragment>
      <Grid
        container
        className={classes.root}
        onClick={() => {
          filterCard == true && setFilterCard(false);
        }}
      >
        <Grid xs={12} sm={12} lg={8} className={classes.topGrid}>
          <CssTextField
            id='loyalty-id'
            placeholder={t('Search for Loyalty Id')}
            type={'number'}
             onWheel={(e) => e.target.blur()}
            variant='outlined'
            onKeyDown={blockInvalidChar}
            autoComplete='off'
            className={classes.searchInput}
            InputProps={{
              endAdornment: (
                <InputAdornment position='end'>
                  {searchValue && searchValue.length > 0 ? (
                    <CloseOutlinedIcon
                      className={classes.searchInputIcon}
                      onClick={() => {
                        setSearchValue('');
                        setOffset(1);
                        handleGet();
                      }}
                    />
                  ) : (
                    <img
                      src={searchIcon}
                      alt=''
                      width='20px'
                      className={classes.searchInputIcon}
                    />
                  )}
                </InputAdornment>
              ),
            }}
            value={searchValue}
            onChange={(e) => {
              setSearchValue(e.target.value);
              if (e.target.value.length == 0) {
                handleGet();
              }
            }}
            onClick={() => {
              setOffset(1);
            }}
          />
          <Button
            className={`${classes.filterBtn} dash-1-filter-btn`}
            onClick={() => {
              setFilterCard(!filterCard);
              if (!states.filter) {
                setStates({ is_active: '', filterRole: '' });
              }
            }}
          >
            {t('Filter')}
            {states.filter && (
              <Badge
                badgeContent={count == 0 ? '' : count}
                classes={{ badge: classes.badge }}
                max={999}
              ></Badge>
            )}
          </Button>
        </Grid>
        <Grid xs={12} sm={12} lg={12} className={classes.cronJobBtnGrid}>
          {selectedData.length > 0 && (
            <Button
              className={classes.cronJobBtn}
              style={{ marginRight: 10 }}
              // disabled={!access['editAccess'][state.userInfo?.role]['max-merch']}
              onClick={()=>{
                if(state?.userInfo?.editAction){
                handleExecute();
                return;
              }
            else{
              toast.error(state.userInfo?.editAccess)
            return;
          }}}
            >
              {t('Execute Maxmerch')}
            </Button>
          )}
          {/* {typeof states.max_merch_cron_job === "boolean" && (
            <Button
              className={classes.cronJobBtn}
              onClick={() => {
                handleUpdateCronJob();
              }}
            >
              {states.max_merch_cron_job ? "Disable" : "Enable Globally"}
            </Button>
          )} */}
        </Grid>
      </Grid>

      {filterCard && (
        <div className={classes.filterCardDiv}>
          <Grid container spacing={0}>
            <Grid item xs={12} style={{ float: 'right' }}>
              <Card className={classes.filterCard}>
                <Grid
                  container
                  spacing={1}
                  className={classes.filterCardGridContainer}
                >
                  <Grid
                    item
                    xs={4}
                    className={classes.filterCardGrid}
                    style={{ padding: '5px 10px 10px 15px' }}
                  >
                    <TextField
                      id={'tier'}
                      label={t('Tier')}
                      select
                      fullWidth
                      type={'text'}
                      value={states.filterTier}
                      onChange={(e) => {
                        setStates({ filterTier: e.target.value });
                      }}
                    >
                      {states.tier.length > 0 &&
                        states.tier.map((e, i) => (
                          <MenuItem value={e.tier} key={i}>
                            {t(e.tier)}
                          </MenuItem>
                        ))}
                    </TextField>
                  </Grid>
                  <Grid
                    item
                    xs={4}
                    className={classes.filterCardGrid}
                    style={{ padding: '5px 10px 10px 10px' }}
                  >
                    <TextField
                      id={'applied-tier'}
                      label={t('Influenced By')}
                      select
                      fullWidth
                      type={'text'}
                      value={states.filterAppliedTier}
                      onChange={(e) => {
                        setStates({ filterAppliedTier: e.target.value });
                      }}
                    >
                      <MenuItem value={'Sales'}>{t("Sales")}</MenuItem>
                      <MenuItem value={'Max Merch'}>{t("Max Merch")}</MenuItem>
                    </TextField>
                  </Grid>
                  <Grid
                    item
                    xs={4}
                    className={classes.filterCardBtnGrid}
                    style={{ padding: 10 }}
                  >
                    <Button
                      className={classes.filterCardApplyBtn}
                      style={{
                        fontSize: 15,
                        height: 35,
                        marginTop: 0,
                      }}
                      onClick={() => {
                        setSearchValue('');
                        setStates({ filter: true });
                        setOffset(1);
                        handleFilter();
                      }}
                    >
                      {t('Apply')}
                    </Button>
                    {states.filter && (
                      <Button
                        className={classes.filterCardResetBtn}
                        onClick={() => {
                          setStates({
                            filter: false,
                            filterTier: '',
                            filterAppliedTier: '',
                          });
                          setOffset(1);
                          setFilterCard(false);
                          handleGet();
                        }}
                      >
                        {t('Reset')}
                      </Button>
                    )}
                  </Grid>
                </Grid>
              </Card>
            </Grid>
          </Grid>
        </div>
      )}
      <Loader Loading={state.loading} top={'15%'}>
        <Grid className={classes.tableDownInResponsive}>
          <Grid xs={12} sm={12} lg={12}>
            <Table
              headings={[
                [
                  <Checkbox
                    onClick={(event) => {
                      if (event.target.checked) {
                        setSelectedData(
                          data
                            ?.map((d) => d?.is_active && d.loyalty_id)
                            ?.filter(Boolean)
                        );
                      } else {
                        setSelectedData([]);
                      }
                    }}
                    checked={selectedData.length === data.length}
                    color='primary'
                  />,
                ],
                'Loyalty Id',
                'Account Status',
                'Billing Account Number',
                'Tier',
                'Sales Tier',
                // 'Max Merch Tier',
                'Influenced By',
                state?.userInfo?.auditAccess? "History":"",
              ]}
              data={
                data &&
                data.length > 0 &&
                data.map((p, i) => [
                  [
                    p?.is_active && (
                      <Checkbox
                        onClick={(event) => {
                          if (event.target.checked) {
                            setSelectedData([...selectedData, p?.loyalty_id]);
                          } else if (selectedData?.includes(p?.loyalty_id)) {
                            let i = selectedData.findIndex(
                              (f) => f == p?.loyalty_id
                            );
                            setSelectedData([
                              ...selectedData.slice(0, i),
                              ...selectedData.slice(i + 1),
                            ]);
                          }
                        }}
                        checked={selectedData.includes(p?.loyalty_id)}
                        inputProps={{ 'aria-labelledby': i }}
                        color='primary'
                      />
                    ),
                  ],
                  p?.loyalty_id,
                  [
                    p?.is_active === true ? (
                      <span style={{ color: 'green' }}>{t("Active")}</span>
                    ) : (
                      <span style={{ color: 'red' }}>{t("InActive")}</span>
                    ),
                  ],
                  p?.customer_billto_account_number,
                  t(p?.tier),
                  t(p?.sales_summary_tier) || '-',
                  // t(p?.max_merch_tier) || '-',
                  p?.applied_tier || '-',
                  (state?.userInfo?.auditAccess) && (
                    <HistoryIcon
                      style={{ cursor: 'pointer' }}
                      onClick={() => {
                        setStates({
                          historyDialog: true,
                          historyLoader: true,
                        });
                        handleGetHistoryData(p?.loyalty_id);
                      }}
                    />
                  ),
                ])
              }
              offset={offset}
              count={
                (count / 10) % 1 == 0
                  ? Math.floor(count / 10)
                  : Math.floor(count / 10 + 1)
              }
              handlePagination={handlePagination}
            />
          </Grid>
        </Grid>
      </Loader>

      {/* history */}
      <Dialog
        aria-labelledby='simple-dialog-title'
        open={states.historyDialog}
        style={{ fontFamily: 'Segoe-ui' }}
        maxWidth={false}
      >
        <div className={classes.dialogParentDiv}>
          <div
            className={classes.parentText}
            style={{
              paddingBottom: 10,
              width: states?.historyData?.length > 0 ? '100%' : 300,
            }}
          >
            {t('History')}{' '}
            <span style={{ float: 'right' }}>
              <HighlightOffIcon
                style={{
                  cursor: 'pointer',
                  color: 'red',
                  fontSize: 35,
                }}
                onClick={() => {
                  setStates({ historyDialog: false, historyData: [] });
                }}
              />
            </span>
          </div>

          {!historyLoader ? (
            <HistoryTable
              headings={[
                'Date of Change',
                'Updated by',
                'Column Name',
                'Description',
              ]}
              data={
                states?.historyData?.length > 0 &&
                states?.historyData.map((d, i) => [
                  d?.created_at
                    ? `${moment(d?.created_at).format('YYYY-MM-DD HH:mm:ss')}`
                    : '',
                  `${d?.['User.email']
                    ? d?.['User.email']
                    : d?.altered_by
                      ? d?.altered_by.charAt(0).toUpperCase() +
                      d?.altered_by.slice(1).toLowerCase()
                      : '-'
                  }`,
                  d?.column_name,
                  `"${d?.old_value}" changed to "${d?.new_value}"`,
                ])
              }
              disablePagination={true}
            />
          ) : (
            <div>
              <Loader Loading={historyLoader} top={'15%'}></Loader>
            </div>
          )}
        </div>
      </Dialog>
    </React.Fragment>
  );
}
